/* eslint-disable class-methods-use-this */
import axios from "axios";

import {
  API_IN_HOUSE,
  API_IN_HOUSE_KEY,
  API_TMS,
  API_TMS_KEY,
  COMMON_HEADER_CONFIG
} from "../config";

class DistributeOrderService {
  getAccessToken = () => localStorage.getItem("accessToken");

  userId = () => localStorage.getItem("userId");

  searchDistributeOrders = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TMS}/delivery-order`,
        params: {
          size: data?.per_page ?? 10,
          page: data?.page ?? 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateStatusWaybill = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_TMS}/update-waybill-status`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  completedWaybillInHouse = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "patch",
        url: `${API_IN_HOUSE}/order/complete/${id}?force=true`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_IN_HOUSE_KEY,
          "x-user-id": this.userId()
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const distributeOrderService = new DistributeOrderService();

export default distributeOrderService;
